import LightLine from "../Lines/Light";
import "./Contact.css";
import { FaLinkedin, FaMailBulk } from "react-icons/fa";

function Contact() {
  return (
    <section id="contact" className="contact">
      <div data-aos="fade-right" className="contact__body">
        <h2 className="contact__heading">Let’s work together</h2>
        <p className="contact__p">If you’re building something ambitious and need someone who can connect technical work with organized execution, I’d be glad to hear from you.</p>
        <div className="contact__option">
          <FaMailBulk className="contact__logo" size={45} />
          <a href="mailto:dallascgiles@gmail.com">
            <span className="contact__text">dallascgiles@gmail.com</span>
          </a>
        </div>
        <div className="contact__option">
          <FaLinkedin className="contact__logo" size={45} />
          <a
            href="https://www.linkedin.com/in/dallas-giles-6a7b762aa/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="my Linkedin"
          >
            <span className="contact__text">Dallas Giles</span>
          </a>
        </div>
      </div>
      <LightLine />
    </section>
  );
}

export default Contact;
